import $ from 'jquery'

//To output svg code via adding "svg" class to an <img> element sourcing .svg file.
$(document).ready(function() {
	$('img.svg').each(function() {
		const $img = $(this)
		const imgID = $img.attr('id')
		const imgClass = $img.attr('class')
		const imgURL = $img.attr('src')

		$.get(
			imgURL,
			function(data) {
				let $svg
				if (!$img.attr('data-replace-colour')) {
					$svg = $(data).find('svg')
				} else {
					//Need to process the svg doc/string, and consider IE 11
					const theXMLSerializer = new XMLSerializer()
					const stringSVG = theXMLSerializer.serializeToString(data)
					const theDomParser = new DOMParser()
					const newSVGDom = theDomParser.parseFromString(
						stringSVG.replace(/#000000/g, '#FEBC11'),
						'image/svg+xml'
					)
					$svg = $(newSVGDom).find('svg')
				}

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID)
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg')
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a')

				// Check if the viewport is set, else we gonna set it if we can.
				if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr(
						'viewBox',
						'0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width')
					)
				}
				// Replace image with new SVG
				$img.replaceWith($svg)
			},
			'xml'
		)
	})
})
